import {I18nMessage} from '@app/shared/api/model/i18n';
import {TimePeriod} from './time-period';
import {History} from '@app/graphql-typings/graphql';

export enum FunctionName {
  NONE = 'NONE',
  ABS = 'ABS',
  CEL = 'CEL',
  FLR = 'FLR',
  RND = 'RND',
  DIF = 'DIF',
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX',
  SUM = 'SUM'
}

/** Functions and labels used by Aggregation Function field when Charts is on x-axis-favourite mode. */
export const AGGREGATION_LABELS_BY_FUNCTION_NAME = new Map<FunctionName, I18nMessage>([
  [FunctionName.AVG, {messageKey: 'Average'}],
  [FunctionName.SUM, {messageKey: 'Sum'}],
  [FunctionName.MIN, {messageKey: 'Min'}],
  [FunctionName.MAX, {messageKey: 'Max'}]
]);

export interface FunctionParams {
  functionName: FunctionName;
  timePeriod: TimePeriod;
}

export interface ChartFunction {
  readonly name: FunctionName;
  readonly longNameKey: string;
  readonly overflow?: number;

  run(history: History[], padValues?: boolean): History[];
}

/** Chart function that accumulates history values into a provided context. */
export interface AccumulatingChartFunction<TContext> extends ChartFunction {
  accumulate(history: Iterable<History>, context: TContext | null): TContext;
  getAggregate(context: TContext): number;
}

export function isAccumulatingChartFunction(chartFunction: ChartFunction | null): chartFunction is AccumulatingChartFunction<unknown> {
  const accumulatingChartFunction: AccumulatingChartFunction<unknown> | null = <any>chartFunction;
  return typeof accumulatingChartFunction?.accumulate === 'function'
    && typeof accumulatingChartFunction.getAggregate === 'function';
}
